module.exports = __webpack_public_path__ + "media/images/default_banner-4e8bcaca.png";